import React, { useEffect, useState } from "react";
import "./Connected.css";

import bg1 from "./assets/bg1.png";
import bg2 from "./assets/bg2.png";
import bg3 from "./assets/bg3.png";
import bg4 from "./assets/bg4.png";
import bg5 from "./assets/bg5.png";

const ConnectedJiviews = () => {
  const [screenWidth, setScreenWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  const [activeId, setActiveId] = useState(null);

  const isMobile = screenWidth <= 768;

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const benefits = [
    {
      id: "automation",
      img: bg1,
      title: "Comprehensive Automation",
      desc: "One-click allocation and planning for maximum efficiency.",
    },
    {
      id: "integration",
      img: bg2,
      title: "Flexible Integration",
      desc: "Works seamlessly with HR, Payroll, Access Control, and Terminal Operating Systems.",
    },
    {
      id: "scalable",
      img: bg3,
      title: "Scalable Solutions",
      desc: "Designed to support businesses of all sizes — from local operations to global enterprises.",
    },
    {
      id: "usability",
      img: bg4,
      title: "Ease of Use",
      desc: "A familiar, spreadsheet-like interface that keeps functionality simple yet powerful.",
    },
    {
      id: "reporting",
      img: bg5,
      title: "Real-Time Reporting",
      desc: "Advanced dashboards and analytics to monitor KPIs, attendance, workload, and performance.",
    },
  ];

  return (
    <section className="jiviews-section">
      {/* Title */}
      <div className="jiviews-header">
        <h2 className="jiviews-title">
          Why Choose JIVIEWS
        </h2>
        <p className="jiviews-subtitle">
          We combine deep domain expertise, innovative technology, and a user-first
          approach to deliver workforce management that truly works.
        </p>
      </div>

      {/* Cards */}
      <div className={`jiviews-container ${isMobile ? "mobile" : ""}`}>
        {benefits.map((card) => {
          const isActive = isMobile || activeId === card.id;

          return (
            <div
              key={card.id}
              className={`jiviews-card ${isActive ? "active" : ""}`}
              style={{ backgroundImage: `url(${card.img})` }}
              onMouseEnter={() => !isMobile && setActiveId(card.id)}
              onMouseLeave={() => !isMobile && setActiveId(null)}
            >
              <div className="jiviews-overlay" />

              {isActive ? (
                <div className="jiviews-content">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                </div>
              ) : (
                <div className="jiviews-vertical-text">
                  {card.title}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ConnectedJiviews;
